/**
 * Migrates brand sections to include the new Brand Colors section
 * This ensures existing brands get the new section added after color-cover
 */

export const migrateBrandColorSection = (sections: any[]): any[] => {
  // Check if brand-colors section already exists
  const hasBrandColors = sections.some(section => section.id === 'brand-colors');

  if (hasBrandColors) {
    return sections; // Already has the section, no migration needed
  }

  // Find the index of color-cover section
  const colorCoverIndex = sections.findIndex(section => section.id === 'color-cover');

  if (colorCoverIndex === -1) {
    return sections; // No color-cover section found, skip migration
  }

  // Create the new brand-colors section
  const brandColorsSection = {
    id: 'brand-colors',
    title: 'Brand Colors',
    content: {
      colorsTitle: 'Brand Colors',
      colorsDescription: 'Our carefully curated color palette reflects our brand identity and creates a cohesive visual experience.',
      brandGuideline: '{{brandName}}/Brand Guideline',
      publishedDate: 'Published Date: {{publishedDate}}',
      brandUrl: 'visit: {{brandUrl}}',
      brandName: 'Brand Name'
    },
    styles: {
      backgroundColor: '#F8F9FA',
      textColor: '#333942',
      fontFamily: 'Helvetica',
      fontSize: '18px',
      padding: '60px',
      position: 'relative'
    },
    customization: {
      backgroundType: 'color',
      backgroundColor: '#F8F9FA',
      backgroundImage: '',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      overlayEnabled: false,
      overlayColor: '#000000',
      overlayOpacity: 0,
      overlayBlendMode: 'normal'
    }
  };

  // Insert the new section right after color-cover
  const newSections = [
    ...sections.slice(0, colorCoverIndex + 1),
    brandColorsSection,
    ...sections.slice(colorCoverIndex + 1)
  ];

  return newSections;
};
